var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22.286px",
    height: "22.286px",
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2858 18.5022V21.9308C16.2858 22.3854 16.1051 22.8215 15.7837 23.143C15.4622 23.4644 15.0261 23.6451 14.5715 23.6451H2.57146C2.1168 23.6451 1.68077 23.4644 1.35928 23.143C1.03779 22.8215 0.857178 22.3854 0.857178 21.9308V3.07366C0.857178 2.619 1.03779 2.18297 1.35928 1.86148C1.68077 1.53999 2.1168 1.35938 2.57146 1.35938H14.5715C15.0261 1.35938 15.4622 1.53999 15.7837 1.86148C16.1051 2.18297 16.2858 2.619 16.2858 3.07366V6.50223M11.1429 12.5022H23.1429M23.1429 12.5022L19.7143 9.07366M23.1429 12.5022L19.7143 15.9308",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu7);
export default __webpack_public_path__ + "static/media/iconMenu7.952cbb60ac4c71e80ac360ed968ae1aa.svg";
export { ForwardRef as ReactComponent };